import { useAuth } from "@certn/auth";
import { DropdownMenu, MenuItem, MenuSection } from "@certn/cascadia-react";
import { Separator } from "@certn/cascadia-react/components/dropdown-menu/assets/Separator";
import { formatName, useGoogleAnalytics } from "@certn/utils";
import { useTranslation } from "react-i18next";
import { useFlags } from "launchdarkly-react-client-sdk";

import { useProfileName } from "../../auth/ProfileProvider";

export function SettingsDropdown() {
  const { t } = useTranslation();
  const { logout, user } = useAuth();

  const { name } = useProfileName();

  const { caseManagementEnableApplicantPayer, enableConsumerDiscountCodes } =
    useFlags();

  const { gaTrackEvent } = useGoogleAnalytics();

  const handleLogout = () => {
    // Clean up localStorage to prevent stale cobranding on next login
    localStorage.removeItem("pending_subject_id");
    logout({ logoutParams: { returnTo: window.location.origin } });
    gaTrackEvent("logout");
    window.location.reload();
  };

  return (
    <DropdownMenu
      label={name.givenName || "unknown"}
      headerTitle={formatName(name)}
      headerText={user?.email}
      onItemAction={(id) => {
        switch (id) {
          case "sign-out":
            handleLogout();
            break;
        }
      }}
      minWidth="256px"
    >
      <MenuSection>
        <MenuItem href="/">{t("Dashboard")}</MenuItem>
        <MenuItem href="/settings/personal-info">{t("Personal info")}</MenuItem>
        <MenuItem id="preferences" href="/settings/preferences">
          {t("Preferences")}
        </MenuItem>
        {caseManagementEnableApplicantPayer && (
          <MenuItem href="/settings/payment-details">
            {t("Payment details")}
          </MenuItem>
        )}
        <MenuItem href="/settings/notifications">{t("Notifications")}</MenuItem>
        <MenuItem href="/settings/help-and-privacy">
          {t("Help & privacy")}
        </MenuItem>
        {enableConsumerDiscountCodes && (
          <MenuItem href="/settings/refer-and-earn">
            {t("Refer and earn")}
          </MenuItem>
        )}
      </MenuSection>
      <Separator />
      <MenuSection>
        <MenuItem id="sign-out">{t("Sign out")}</MenuItem>
      </MenuSection>
    </DropdownMenu>
  );
}
